import * as documentsAPI from '@debbie/cortex/dist/api/documents.js'
import { useCase } from '@debbie/cortex/dist/cases/index.js'
import { h } from '@debbie/cortex/dist/index.js'
import PlaceholderLoader from '@debbie/iris/dist/components/PlaceholderLoader.js'
import React, { useEffect } from 'react'
import { useParams } from 'react-router-dom'

const DocumentSigning = () => {
  const params: { handle: string; caseSequentialId: string } = useParams()
  const { handle, caseSequentialId } = params

  const caseIdLoader = useCase(caseSequentialId)
  const caseId = h.hasData(caseIdLoader) ? caseIdLoader.data.caseId : null
  const singleCaseLoader = useCase(caseId)
  const singleCase = h.hasData(singleCaseLoader) ? singleCaseLoader.data : null

  const getSigningLink = async () => {
    if (singleCase == null) {
      throw new Error('Case not loaded')
    }
    try {
      const link = await documentsAPI.getSigningLink(
        singleCase.caseId,
        handle,
        window.location.origin + '/signed',
        window.location.origin + '/declined-signing',
      )

      location.replace(link.url)
    } catch (error) {
      console.error(error)
      alert('Error. Please try again later.')
    }
  }

  useEffect(() => {
    if (handle && singleCase) {
      getSigningLink()
    }
  }, [singleCase, handle])

  return (
    <div>
      <PlaceholderLoader />
    </div>
  )
}

export default DocumentSigning
